// ENGLISH

export default {
    values: {
        'Type to search': 'Type to search',
        REMOVE: 'REMOVE',
        Creating: 'Creating',
        Create: 'Create',
        Close: 'Close',
        'Confirm deletion': 'Confirm deletion',
        'No, I do not': 'No, I do not',
        of: 'of',
        items: 'items',
        Default: 'Default',
        Ascending: 'Ascending',
        Descending: 'Descending',
        All: 'All',
        Description: 'Description',
        Name: 'Name',
        Save: 'Save',
        Showing: 'Showing',
        Search: 'Search',
        Settings: 'Settings',
        'New Channel': 'New Channel',
        'Edit Channel': 'Edit Channel',
        'All Channels': 'All Channels',
        'There are no channels yet': 'There are no channels yet',
        'Real Time Channels': 'Real Time Channels',
        channels: 'channels',
        channel: 'channel',
        'Channel name': 'Channel name',
        Type: 'Type',
        'Type to search for name or ID': 'Type to search for name or ID',
        Number: 'Number',
        'If you really want to delete the channel, type': 'If you really want to delete the channel, type',
        'Channel created successfully.': 'Channel created successfully.',
        'An error occurred on creating channel.': 'An error occurred on creating channel.',
        'Other Channel with same Id already registered': 'Other Channel with same ID already registered',
        'An error ocurred on listing channel types': 'An error ocurred on listing channel types',
        'Channel updated successfully.': 'Channel updated successfully.',
        'An error occurred on updating channel.': 'An error occurred on updating channel.',
        'Are you sure you want remove the channel': 'Are you sure you want remove the channel',
        'Missing id': 'Missing ID',
        'channel deleted.': 'Channel deleted successfully.',
        'An error occurred on deleted channel.': 'An error occurred on deleted channel.',
        'Delete channel': 'Delete channel',
        Select: 'Select',
        'Channel is being used on one more resources.': 'The channel is being used by one or more resources'
    }
}
